import React from 'react';
import { IEmptyBlock } from '../../../../forms/base/controls/content/EmptyBlock';
import { RPDF } from '../../../react-pdf';

export const EmptyBlock: IEmptyBlock = () => {
  return <RPDF.View />;
};
